import moment from "moment/moment";
import { GAME_TYPE, QUESTION_TYPE } from "../constants";

const baseRoute = (name = "") => {
  return `${process.env.REACT_APP_DOMAIN_DIR}/${name}`;
};

const apiBaseUrl = () => {
  return process.env.REACT_APP_API_DOMAIN + "api/user/";
};

const localStorageToken = () => {
  return process.env.REACT_APP_WEB_STORAGE_TOKEN;
};

const getStatusClass = (status) => {
  switch (status) {
    case 10:
      return "SCHEDULED";
    case 15:
      return "ONGOING";
    case 20:
      return "CANCELLED";
    case 25:
      return "ON_HOLD";
    case 30:
      return "COMPLETED";
    default:
      return "";
  }
};

const getCriteriaType = (status) => {
  switch (status) {
    case 10:
      return "POLL VOTE";
    case 20:
      return "POLL WIN";
    default:
      return "";
  }
};

const getOrderStatus = (status) => {
  switch (status) {
    case 10:
      return "ORDERED";
    case 20:
      return "PAID";
    case 30:
      return "READY FOR DELIVERY";
    case 40:
      return "DELIVERED";
    case 41:
      return "REVIEWED";
    case 50:
      return "CANCELLED";
    default:
      return "";
  }
};

const statusValues = [10, 20, 30, 40, 41, 50];

const getOrderType = (type) => {
  switch (type) {
    case 10:
      return "PICKUP";
    case 20:
      return "DELIVERY";
    default:
      return "";
  }
};
const typeValues = [10, 20];

const shopStatus = [10, 20, 30];

const getShopStatus = (status) => {
  switch (status) {
    case 10:
      return "Approval Pending";
    case 20:
      return "Approved";
    case 30:
      return "Rejected";
    default:
      return "";
  }
};

const CATEGORY_TYPE = { FOOD: 10, FASHION: 20, OTHER: 30 };

const getCategoryType = (type) => {
  switch (type) {
    case CATEGORY_TYPE.FOOD:
      return "Food";
    case CATEGORY_TYPE.FASHION:
      return "Fashion";
    case CATEGORY_TYPE.OTHER:
      return "Other";
    default:
      return "";
  }
};

const typeList = [
  { label: "POLL VOTE", value: 10 },
  { label: "POLL WIN", value: 20 },
];

const getTypes = (value) => {
  const type = typeList.find((item) => item.value === value);
  return type ? type.label : "Unknown";
};

const POLL_STATUS = {
  UPCOMING: 10,
  ONGOING: 20,
  EXPIRED: 30,
  CANCELLED: 40,
};
const POLL_TYPE = {
  SUGGESTION: 10,
  ADMIN_CREATED: 20,
};

const POLL_STATUS_LIST = [
  { label: "UPCOMING", value: 10 },
  { label: "ONGOING", value: 20 },
  { label: "EXPIRED", value: 30 },
  { label: "CANCELLED", value: 40 },
];

const POLL_TYPE_LIST = [
  { label: "SUGGESTION", value: 10 },
  { label: "ADMIN_CREATED", value: 20 },
];

const getPollStatus = (value) => {
  return (
    POLL_STATUS_LIST.find((status) => status.value === value)?.label ||
    "Unknown"
  );
};

const getPollType = (value) => {
  return (
    POLL_TYPE_LIST.find((type) => type.value === value)?.label || "Unknown"
  );
};

const formatDateTimeLocal = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);

  return date.toISOString().slice(0, 16);
};

const getMessageTime = (timestamp) => {
  if (!moment(timestamp).isValid()) return "";
  return moment(timestamp).format("hh:mm A");
};

export {
  getMessageTime,
  formatDateTimeLocal,
  POLL_STATUS,
  POLL_TYPE,
  POLL_STATUS_LIST,
  POLL_TYPE_LIST,
  getPollStatus,
  getPollType,
  baseRoute,
  apiBaseUrl,
  localStorageToken,
  getStatusClass,
  getCriteriaType,
  getOrderStatus,
  getOrderType,
  getShopStatus,
  getCategoryType,
  getTypes,
  CATEGORY_TYPE,
  statusValues,
  typeValues,
  shopStatus,
  typeList,
};
